import useFetch from '@hooks/useFetch';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import processPurchaseData from '@api/processors/purchaseData';
import { getIsLoggedIn } from '@api/selectors/auth';
import { useMemo } from 'react';

const usePurchasedItems = (selector) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { data: purchasedItems, ...rest } = useFetch(
    isLoggedIn ? 'v1/user/purchased_items/' : null,
    { useCamelCase: false }
  );
  const processedPurchaseData = useMemo(
    () => processPurchaseData(purchasedItems),
    [purchasedItems]
  );
  if (typeof selector === 'function') return selector(processedPurchaseData);
  return { purchasedItems: processedPurchaseData, ...rest };
};

export default usePurchasedItems;
